import { apiSlice } from './apiSlice'

/**
 * Sales Control › Debit Note PRINT preview query (Access Debit Note screen).
 * New slice — conflict-free with saleDebitNoteApi.ts (owned by another agent).
 *
 *   getDebitNotePrintPreview → GET /sale-debit-notes/print/preview?id={id}
 *
 * The print is keyed by ONE claim_debit_scs_id (the selected row). The backend
 * resolves the layout variant from the row claim_type ("Weight claims" → Weight
 * layout; any other type → Quality layout). Returns { title, html, message }.
 * 422 detail = user-facing English message (debit note not found). Frame passes
 * only the id. keepUnusedDataFor: 0 (always refetch).
 */
type PrintPreview = { title: string; html: string; message?: string }

const saleDebitNotePrintApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getDebitNotePrintPreview: builder.query<PrintPreview, number>({
      query: (id) => ({
        url: '/sale-debit-notes/print/preview',
        params: { id },
      }),
      keepUnusedDataFor: 0,
    }),
  }),
  overrideExisting: false,
})

export const { useLazyGetDebitNotePrintPreviewQuery } = saleDebitNotePrintApi

export default saleDebitNotePrintApi
